// extracted by mini-css-extract-plugin
export default {"wrapper":"oy-z","button":"py-z","alternate":"qy-z","disabled":"ry-z","paymentWarning":"sy-z","fadeIn":"ty-z"};